import { Button } from "@/shared/ui/button";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useTranslation } from "@/shared/i18n";

interface CategoryFormActionsProps {
    isEditing: boolean;
    isSubmitting: boolean;
}

export const CategoryFormActions = ({ isEditing, isSubmitting }: CategoryFormActionsProps) => {
    const { t } = useTranslation('categories');
    const navigate = useNavigate();

    return (
        <div className="flex justify-end gap-4">
            <Button
                type="button"
                variant="outline"
                onClick={() => navigate("/categories")}
                className="bg-transparent border-[#333333] text-white hover:bg-[#222222]"
            >
                {t('cancel')}
            </Button>
            <Button
                type="submit"
                disabled={isSubmitting}
                className="bg-[#D91657] hover:bg-[#D91657]/90 text-white"
            >
                {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                {isSubmitting
                    ? t('saving')
                    : isEditing
                        ? t('update')
                        : t('createCategory')
                }
            </Button>
        </div>
    );
};